module.exports = __webpack_public_path__ + "img/img8.168d586c.svg";